import { memo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * GeneralLoading component displays a loading indicator centered within a div.
 * It uses a CircularProgress component to indicate loading status.
 *
 * @returns {JSX.Element} A div containing the loading indicator.
 */
function GeneralLoading(): JSX.Element {
  return (
    <div
      style={{
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress size={30} />
    </div>
  );
}

export default memo(GeneralLoading);
